import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MAX_FILEUPLOAD_SIZE,
         Unsupported_file_format,
         Maximum_file_upload_size_should_be_10MB,
         Error_while_saving_the_data
       } from '@root/app.constant';
import { CatalogService } from '@catalog/catalog.service';
import { NgForm } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-catalogue-excel',
  templateUrl: './catalogue-excel.component.html',
  styleUrls: ['./catalogue-excel.component.scss'],
  providers: [CatalogService],
})
export class CatalogueExcelComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;
  category: string;

  @Input() categoryList: any;

  file: File;

  fileName: string;

  excelList = [];

  constructor(
    private toastr: ToastrService,
    private catalogService: CatalogService
  ) {}

  ngOnInit() {
    //this.getCategories();
  }

  public onFileChange(file: File) {
    this.file = file;
    if (this.file) {
      let isValid =  true;
      const fsize = this.file.size;

      const fileType = file.name.split('.').pop();
      if (fileType !== 'xls' && fileType !== 'xlsx') {
        this.toastr.error(Unsupported_file_format);
        isValid =  false;
      }else if (fsize > MAX_FILEUPLOAD_SIZE) {
        this.toastr.error(Maximum_file_upload_size_should_be_10MB);
        isValid =  false;
      }
      if(!isValid){
        this.clearFileComponent();
      }
    } else {
      this.fileName = null;
    }
  }

  private clearFileComponent(){
      this.file = null;
      setTimeout(() => {
        this.fileName = null;
      });
  }

  public processData() {
    const formData: any = new FormData();
    formData.append('file', this.file);
    console.log(this.category);
    

    this.catalogService.uploadExcelData(formData, this.category).subscribe(
      (response) => {
        if (response.status === -1) {
          this.toastr.error(response.error.errorMessage);
        } else {
          this.toastr.success(response.message);
          this.readContentHistory();
        }

        this.resetData(this.category);
      },
      (error) => {
        if (error.error.errorMessage === null) {
          this.toastr.error(Error_while_saving_the_data);
        } else {
          this.toastr.error(error.errorMessage);
        }
      }
    );
  }

  public resetData(category: string){
    this.fileName = null;
    this.form.resetForm();
    setTimeout(() => {
      this.category = category ? category : null;
    });
  };

  public onSelectionChange(change: MatSelectChange) {
    this.readContentHistory();
  }

  public readContentHistory() {
    const obj = {
      category: this.category,
    };
    this.catalogService.readExcelContentHistory(obj).subscribe(
      (response) => {
        this.excelList = [...response.data.list];
      },
      (error) => {}
    );
  }
}
